import React from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Image, Spin } from 'antd'

const ITEM_IMAGE_QUERY = gql`
  query ItemProductImage($itemId: String!) {
    item(itemId: $itemId) {
      id
      externalId
      image {
        id
        small
        original
      }
    }
  }
`

const ItemProductImage = ({ itemExternalId }) => {
    const { loading, data } = useQuery(ITEM_IMAGE_QUERY, {
        variables: { itemId: `${itemExternalId}` },
        skip: !itemExternalId
    })

    if (!itemExternalId) return null
    if (loading) return <Spin size="small" />

    const image = data && data.item && data.item.image
    if (!image || !image.small) return null

    return (
        <Image
            src={image.small}
            preview={{ src: image.original || image.small }}
            width={48}
            height={48}
            style={{ objectFit: 'cover', borderRadius: 4 }}
        />
    )
}

ItemProductImage.propTypes = {
    itemExternalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default ItemProductImage
